import type { ModelsErrorResponse } from '@barbershop/api/customer'

interface ApiError {
    response?: {
        data?: ModelsErrorResponse
        status?: number
    }
}

export const ERROR_CODES = {
    BOOKING_LIMIT_REACHED: 1002,
    SLOT_UNAVAILABLE: 1010,
    HOLD_EXPIRED: 1011,
}

export const ERROR_MESSAGES = new Map<number, string>([
    [ERROR_CODES.SLOT_UNAVAILABLE, 'Это время уже заняли. Выберите другое время'],
    [ERROR_CODES.HOLD_EXPIRED, 'Резерв истёк. Запишитесь заново'],
    [
        ERROR_CODES.BOOKING_LIMIT_REACHED,
        'Больше 5 активных записей создать нельзя — отмените одну из них',
    ],
])

export const getErrorCode = (error: unknown) => {
    return (error as ApiError | undefined)?.response?.data?.error_code
}

export const getErrorStatus = (error: unknown) => {
    return (error as ApiError | undefined)?.response?.status
}

export const getErrorMessage = (errorCode?: number) => {
    if (!errorCode) {
        return 'Неизвестная ошибка. Код ошибки отсутствует'
    }

    if (ERROR_MESSAGES.has(errorCode)) {
        return ERROR_MESSAGES.get(errorCode)
    }

    return `Серверная ошибка. Код ошибки: ${errorCode}`
}
